import { FORMAT, formatDateTime } from "Common/dateTimeUtils/format";
import get from "lodash/get";
import React from "react";
export function TextCell({ displayValue }) {
    return React.createElement("span", null, displayValue);
}
export function DateCell({ data, column }) {
    const ms = column.dataField ? get(data, column.dataField) : 0;
    return ms ? formatDateTime(ms, FORMAT.DATE) : "";
}
export function DateTimeCell({ data, column }) {
    const ms = column.dataField ? get(data, column.dataField) : 0;
    return ms ? formatDateTime(ms, FORMAT.DATE_TIME) : "";
}
